<template>
    <el-dialog
            :title="title"
            :visible.sync="showDlg"
            :fullscreen=true
            :lock-scroll="false"
            :append-to-body="true"
            :close-on-click-modal="false"
            class="dlg-normal">

        <el-form :model="agentInfoForm" :rules="rules" ref="agentInfoForm" label-position="top">

            <el-tabs v-model="activeTabName" @tab-click="handleMainTabClick">
                <el-tab-pane label="服务商信息" name="tab1">
                    <div>
                        <div class="tipTitle">基本信息</div>
                        <div class="form-s">
                            <el-row :gutter="30">
                                <el-col :span="c1">
                                    <el-form-item label="服务商编号" prop="agentCode">
                                        <el-input size="small" v-model="agentInfoForm.agentCode" placeholder="系统自动生成" :disabled="true"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="c1">
                                    <el-form-item label="服务商等级" prop="agentLevelId">
                                        <el-select v-model="agentInfoForm.agentLevelId" placeholder="服务商等级" size="small" disabled
                                                   style="width: 100%;">
                                            <el-option
                                                    v-for="item in _enums.AgentLevelEnum"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="c1">
                                    <el-form-item label="服务商来源" prop="agentPid">
                                        <el-select v-model="agentInfoForm.agentPid" placeholder="推荐人" size="small" filterable disabled
                                                   style="width: 100%;">
                                            <el-option
                                                    v-for="item in arch_allAgentIdNameWithOutThis"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="c1">
                                    <el-form-item label="服务商性质" prop="agentNatureId">
                                        <el-select v-model="agentInfoForm.agentNatureId" size="small" placeholder="服务商性质"
                                                   style="width: 100%;">
                                            <el-option
                                                    v-for="item in _enums.AgentNatureEnum"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="30">
                                <el-col :span="c1">
                                    <el-form-item label="服务商名称" prop="agentName">
                                        <el-input :disabled="inOptType!=='INS'" size="small" v-model="agentInfoForm.agentName" placeholder="服务商名称"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="c1">
                                    <el-form-item label="服务商简称" prop="shortName">
                                        <el-input :disabled="inOptType!=='INS'" size="small" v-model="agentInfoForm.shortName" placeholder="服务商简称" />
                                    </el-form-item>
                                </el-col>
                                <el-form :model="otherForm" ref="otherForm" :rules="otherRules">
                                    <el-col :span="c2">
                                        <el-form-item label="地区" prop="areas">
                                            <AreaSelect  v-bind:inAreas="otherForm.areas" v-bind:outAreas.sync="otherForm.areas" />
                                        </el-form-item>
                                    </el-col>
                                </el-form>
                            </el-row>
                            <el-row :gutter="30">
                                <el-col :span="c1">
                                    <el-form-item label="负责人" prop="linkMan">
                                        <el-input size="small" v-model="agentInfoForm.linkMan" placeholder="负责人" />
                                    </el-form-item>
                                </el-col>
                                <el-col :span="c1">
                                    <el-form-item label="联系电话" prop="linkPhone">
                                        <el-input size="small" v-model="agentInfoForm.linkPhone" placeholder="联系电话" />
                                    </el-form-item>
                                </el-col>
                                <el-col :span="c1">
                                    <el-form-item label="详细地址" prop="addr">
                                        <el-input size="small" v-model="agentInfoForm.addr" placeholder="详细地址" />
                                    </el-form-item>
                                </el-col>
                                <el-col :span="c1">
                                    <el-form-item label="联系邮箱" prop="linkMail">
                                        <el-input size="small" v-model="agentInfoForm.linkMail" placeholder="电子邮箱" />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <!--
                            <el-row :gutter="30">
                                <el-col :span="c1">
                                    <el-form-item label="法人姓名" prop="legalPerson">
                                        <el-input size="small" v-model="agentInfoForm.legalPerson" placeholder="法人姓名" />
                                    </el-form-item>
                                </el-col>
                                <el-col :span="c1">
                                    <el-form-item label="法人电话" prop="legalPhone">
                                        <el-input size="small" v-model="agentInfoForm.legalPhone" placeholder="法人电话" />
                                    </el-form-item>
                                </el-col>
                                <el-col :span="c1">
                                    <el-form-item label="法人身份证号" prop="legalIdcardNo">
                                        <el-input size="small" v-model="agentInfoForm.legalIdcardNo" placeholder="法人身份证号" />
                                    </el-form-item>
                                </el-col>
                                <el-col :span="c1">
                                    <el-form-item label="营业执照编号" prop="licenseCode">
                                        <el-input size="small" v-model="agentInfoForm.licenseCode" placeholder="营业执照编号" />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            -->
                            <el-row :gutter="30">
                                <el-col :span="c1">
                                    <el-form-item label="营业执照图片" prop="licensePhoto">
                                        <ImgUpload v-if="img1Rest" v-bind:inImgUrl="agentInfoForm.licensePhoto" v-bind:outImgUrl.sync="agentInfoForm.licensePhoto" />
                                    </el-form-item>
                                </el-col>


                            </el-row>

                        </div>
                        <el-divider></el-divider>
                        <div class="tipTitle">合同信息</div>
                        <div class="form-s">
                            <el-row :gutter="30">
                                <el-col :span="c1">
                                    <el-form-item  label="合同编号" prop="contractNo">
                                        <el-input disabled size="small" v-model="agentInfoForm.contractNo" placeholder="合同编号" />
                                    </el-form-item>
                                </el-col>
                                <el-col :span="c1">
                                    <el-form-item label="* 合同时间">
                                        <el-form-item prop='contractBeg'>
                                            <el-date-picker :disabled="true" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width: auto" placeholder="开始日期" v-model="agentInfoForm.contractBeg" />
                                        </el-form-item>
                                        <el-form-item>&nbsp;-&nbsp;</el-form-item>
                                        <el-form-item prop='contractEnd'>
                                            <el-date-picker :disabled="true" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width: auto" placeholder="结束日期" v-model="agentInfoForm.contractEnd" />
                                        </el-form-item>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="c1">
                                    <el-form-item label="分润比例" prop="contractReward">
                                        <el-input-number disabled v-model="agentInfoForm.contractReward" :precision="2" :min="0" :max="1" :step="0.1" >
                                        </el-input-number>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>

                        <el-divider></el-divider>

                        <div class="tipTitle">结算账户</div>
                        <div class="form-s">
                            <el-row :gutter="30">
                                <el-col :span="c1">
                                    <el-form-item label="账户类型" prop="stlAccTypeId">
                                        <el-select v-model="agentInfoForm.stlAccTypeId" size="small" placeholder="账户类型"
                                                   style="width: 100%;">
                                            <el-option
                                                    v-for="item in _enums.SettleTypeEnum3"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="c3">
                                    <el-form-item label="开户银行" prop="stlBankCnapsCode">
                                        <BankSelect v-if="bankRest" v-bind:inCnapsCode="agentInfoForm.stlBankCnapsCode" v-bind:outCnapsCode.sync="agentInfoForm.stlBankCnapsCode" />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="30">
                                <el-col :span="c1">
                                    <el-form-item label="开户名称" prop="stlAccName">
                                        <el-input size="small" v-model="agentInfoForm.stlAccName" placeholder="开户名称" />
                                    </el-form-item>
                                </el-col>
                                <el-col :span="c1">
                                    <el-form-item label="银行卡号" prop="stlAccNo">
                                        <el-input size="small" v-model="agentInfoForm.stlAccNo" placeholder="银行卡号" />
                                    </el-form-item>
                                </el-col>
                                <el-col :span="c1">
                                    <el-form-item label="开卡手机号" prop="stlAccPhone">
                                        <el-input size="small" v-model="agentInfoForm.stlAccPhone" placeholder="开卡手机号" />
                                    </el-form-item>
                                </el-col>
                                <el-col :span="c1">
                                    <el-form-item label="开卡身份证号" prop="stlAccIdcardNo">
                                        <el-input size="small" v-model="agentInfoForm.stlAccIdcardNo" placeholder="开卡身份证号" />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>


                        <!--
                        <div v-if="inOptType==='INS'">
                            <el-divider></el-divider>
                            <div class="tipTitle">系统账号</div>
                            <div class="form-s">
                                <el-row :gutter="30">
                                    <el-col :span="c1">
                                        <el-form-item label="主账号名称" prop="sysName">
                                            <el-input size="small" v-model="agentInfoForm.sysName" placeholder="主账号名称" />
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="c1">
                                        <el-form-item label="主账号" prop="sysUserName">
                                            <el-input size="small" v-model="agentInfoForm.sysUserName" placeholder="主账号，建议填写手机号" />
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                        -->
                        <div style="height: 20px" />


                    </div>
                </el-tab-pane>
                <el-tab-pane label="产品和费率" name="tab2" :disabled="tab2Disable">
                    <div class="tipTitle">产品选择</div>
                    <div class="form-s">
                        <el-table :data="agentInfoForm.userProductList" v-loading="loading" size="mini" border
                                  :header-cell-style="{background:'#fafafa'}"
                                  ref="prodTable">
                            <el-table-column type="selection" width="55"/>
                            <el-table-column label="产品名称" width="150" align="center">
                                <template slot-scope="scope">
                                    <el-tag type="warning" effect="dark" style="height: 25px">
                                        <span style="font-size: 15px">{{scope.row.payProduct.productName}}</span>
                                    </el-tag>
                                </template>
                            </el-table-column>

                            <el-table-column label="费率信息" prop="payProductChannelList" align="center">
                                <template slot="header">
                                    <el-tooltip placement="top">
                                        <div slot="content" >
                                            设置服务商的成本费率、终端的结算费率模板，<br/><br/>若未设置终端费率模板，则按照公司固定费率。
                                        </div>
                                        <span style="color: green;">费率信息 <i class="el-icon-question"/></span>
                                    </el-tooltip>
                                </template>
                                <template slot-scope="scope">
                                    <el-table :data="scope.row.payProductChannelList" type="expand" :show-header="false"
                                    >
                                        <el-table-column width="150" align="center"
                                                         label="交易方式">
                                            <template slot-scope="scope">
                                                {{scope.row.payName}}
                                            </template>
                                        </el-table-column>

                                        <el-table-column label="费率" prop="userRateList" align="center">
                                            <template slot-scope="scope">
                                                <el-table :data="scope.row.userRateList" type="expand" :header-cell-style="{background:'#fafafa'}">
                                                    <el-table-column label="费率类型" prop="rateTypeDesc" />
                                                    <el-table-column label="服务商费率（%）">
                                                        <template slot-scope="scope">
                                                            <span v-if="scope.row.rate===null">--</span>
                                                            <el-input-number disabled v-else-if="scope.row.rateType===1" :precision="2" :min=Number(0.02)  :controls="false" v-model="scope.row.rate" :key="scope.row.id" />
                                                            <el-input-number v-else :disabled="inOptType!=='INS'" :precision="2" :min="arch_miniRate[scope.row.id].rate"  :controls="false" v-model="scope.row.rate" :key="scope.row.id" />
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="单笔固定（元）" >
                                                        <template slot-scope="scope">
                                                            <span v-if="scope.row.fixRate===null">--</span>
                                                            <el-input-number v-else :precision="2" :min="arch_miniRate[scope.row.id].fixRate"   :controls="false" v-model="scope.row.fixRate" :key="scope.row.id" />
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="单笔最低（元）">
                                                        <template slot-scope="scope">
                                                            <span v-if="scope.row.feeLowest===null">--</span>
                                                            <el-input-number v-else disabled :precision="2" :min=arch_miniRate[scope.row.id].feeLowest :controls="false" v-model="scope.row.feeLowest" :key="scope.row.id" />
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="单笔封顶（元）">
                                                        <template slot-scope="scope">
                                                            <span v-if="scope.row.feeHighest===null">--</span>
                                                            <el-input-number v-else :precision="2" :min="arch_miniRate[scope.row.id].feeHighest" :controls="false" v-model="scope.row.feeHighest" :key="scope.row.id" />
                                                        </template>
                                                    </el-table-column>

                                                </el-table>


                                            </template>
                                        </el-table-column>
                                    </el-table>

                                    <div class="tipTitle" style="display: flex; justify-content: left;">
                                        <!--
                                        <span style="font-weight:bold;font-size: 12px; color: red;">到账周期：{{scope.row.payProduct.settleCycle===1?'D0':'D1'}}</span>
                                        -->
                                        <span style="font-weight:normal;font-size: 12px; color: gray;">&nbsp;&nbsp;{{_enums.ProductChannelEnum.getDescById(scope.row.payProduct.productCode)}}</span>
                                    </div>

                                </template>
                            </el-table-column>
                        </el-table>


                    </div>
                </el-tab-pane>
            </el-tabs>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="showDlg = false">取 消</el-button>
            <el-button size="small" type="primary" @click="handleMainDlgOkClick">确 定</el-button>
        </span>
        <!--
        <remote-js src="http://pv.sohu.com/cityjson?ie=utf-8"></remote-js>
        -->
    </el-dialog>
</template>

<script>
    import ImgUpload from "../pub/ImgUpload";
    import AreaSelect from "../pub/AreaSelect";
    import BankSelect from "../pub/BankSelect";
    import {URL_AGENT_FROMS, URL_DATA_USER_BASE_PRORATE} from "../../utils/cons";
    import {deepClone, findIdxByKeyValue, curDate, curDateFull, nextCurDateFull, guid} from "../../utils/datatool";
    import {MiniRate} from "../../utils/MiniRate";
    export default {
        name: "AgentBaseDlg",
        props:["inOptType", "inAgentInfo"],
        components: {ImgUpload, AreaSelect, BankSelect,
            /**
            'remote-js': { // 搜狐接口获取本地外网IP
                render(createElement) {
                    return createElement('script', { attrs: { type: 'text/javascript', src: this.src }});
                },
                props: {
                    src: { type: String, required: true },
                },
            }
            */
        },
        data() {
            let checkAreas=(rule, value, callback) => {
                if (value) {
                    if(value.provId===null || value.provId.length===0) callback(new Error('请选择省份'));
                    else if(value.cityId===null || value.cityId.length===0) callback(new Error('请选择城市'));
                    else if(value.distId===null || value.distId.length===0) callback(new Error('请选择区县'));
                    else callback();
                }
                else callback(new Error('请选择区域'));
            };
            return {
                arch_miniRate: null,
                activeTabName: 'tab1',
                loading: false,
                slChecked: false,
                jhChecked: false,
                title: null,
                tab2Disable: true,
                showDlg: false,
                c0: 3,
                c1: 6,
                c2: 12,
                c3: 18,
                c4: 24,
                bankRest: true,
                img1Rest: true,
                arch_allAgentIdNameWithOutThis: null,
                arch_my_userBaseProductRateInfo: [],
                otherForm: {
                    areas:{ provId: null, cityId: null, distId: null }
                },
                businessArr:[],
                agentInfoForm: {
                    ysfTermRateArray: [],
                    userProductList: [],
                    id: null,
                    agentCode: null,
                    agentName: null,
                    shortName: null,
                    provId: '',
                    provIdName: '',
                    cityId: '',
                    cityIdName: '',
                    distId: '',
                    distIdName: '',
                    addr: null,
                    tel: null,
                    linkMan: null,
                    linkPhone: null,
                    linkMail: null,
                    licenseCode: null,
                    licensePhoto: null,
                    legalPerson: null,
                    legalPhone: null,
                    legalIdcardNo: null,
                    legalIdcardPhoto: null,
                    contractNo: null,
                    contractReward: 1.00,
                    contractBeg: null,
                    contractEnd: null,
                    agentFee: null,
                    recvAgentFee: null,
                    stlBankCnapsCode: null,
                    settleCnaps: {cnapsCode:null,cnapsName:null},
                    stlAccNo: null,
                    stlAccIdcardNo: null,
                    stlAccName: null,
                    stlAccPhone: null,
                    agentLevelId: 1,
                    agentLevel: {id:null,name:null},
                    agentNatureId: 2,
                    agentNature: {id:null,name:null},
                    stlAccTypeId: 2,
                    settleAccType: {id:null,name:null},
                    agentStatusId: null,
                    agentStatus: {id:null,name:null},
                    agentPid: null,
                    agentPidName: null,
                    remark: null,
                    sysName: null,
                    sysUserName: null
                },
                otherRules: {
                    'areas' : [{required: true, trigger: 'blur', validator:checkAreas}],
                },
                rules: {
                    /// 'sysName': [{required: true, message: '请输入主账号名称', trigger: 'blur'}],
                    /// 'sysUserName': [{required: true, message: '请输入主账号', trigger: 'blur'}],
                    'agentName': [{required: true, message: '请输入服务商名称', trigger: 'blur'}],
                    'shortName': [{required: true, message: '请输入服务商简称', trigger: 'blur'}],
                    'agentPid': [{required: true, message: '请选择服务商来源（推荐人）', trigger: 'blur'}],
                    /// 'addr': [{required: true, message: '请输入服务商详细地址', trigger: 'blur'}],
                    'agentLevelId': [{required: true, message: '请选择服务商等级', trigger: 'blur'}],
                    'agentNatureId': [{required: true, message: '请选择服务商性质', trigger: 'blur'}],
                    'linkMan': [{required: true, message: '请输入联系人', trigger: 'blur'}],
                    'linkPhone': [{required: true, message: '请输入联系电话', trigger: 'blur'}],
                    /// 'linkMail': [{required: true, message: '请输入联系邮箱', trigger: 'blur'}, { type: 'email', message: '邮箱格式不正确', trigger: 'blur'}],
                    //'legalPerson': [{required: true, message: '请输入法人姓名', trigger: 'blur'}],
                    //'legalPhone': [{required: true, message: '请输入法人电话', trigger: 'blur'}],
                    //'legalIdcardNo': [{required: true, message: '请法人身份证号码', trigger: 'blur'}, { pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/, message: '身份证号码格式不正确', trigger: 'blur'}],
                    //'licenseCode': [{required: true, message: '请输入营业执照编号', trigger: 'blur'}],
                    //'licensePhoto': [{required: true, message: '请选择营业执照照片', trigger: 'blur'}],
                    'contractNo': [{required: true, message: '请输入合同编号', trigger: 'blur'}],
                    'contractReward': [{required: true, message: '请输入分润比例', trigger: 'blur'}],
                    'contractBeg': [{required: true, message: '请选择合同开始日期', trigger: 'blur'}],
                    'contractEnd': [{required: true, message: '请选择合同结束日期', trigger: 'blur'}],

                    /// 'stlAccTypeId': [{required: true, message: '请选择结算账户类型', trigger: 'blur'}],
                    /// 'stlBankCnapsCode': [{required: true, message: '请选择开户行', trigger: 'blur'}],
                    /// 'stlAccName': [{required: true, message: '请输入开户名称', trigger: 'blur'}],
                    /// 'stlAccNo': [{required: true, message: '请输入开户卡号', trigger: 'blur'}],
                    /// 'stlAccPhone': [{required: true, message: '请输入开户手机号', trigger: 'blur'}],
                    /// 'stlAccIdcardNo': [{required: true, message: '请输入开户身份证号', trigger: 'blur'}]
                    // 'stlAccIdcardNo': [{required: true, message: '请输入开户身份证号', trigger: 'blur'}, { pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/, message: '身份证号码格式不正确', trigger: 'blur'}]

                }
            };
        },
        //////////////////////////////////////////////////////////////////////
        // 组件初始化加载
        //////////////////////////////////////////////////////////////////////
        mounted() {
            switch (this.inOptType) {
                case 'INS':
                    this.title = '新增服务商信息';
                    let sn = guid()
                    // console.log(sn, sn.substr(14,5))
                    this.agentInfoForm.contractNo = 'LSH-LKL-' + curDate() + sn.substr(13,6)
                    this.agentInfoForm.contractBeg = curDateFull()
                    this.agentInfoForm.contractEnd = nextCurDateFull()
                    // 我的 用户基础产品费率档案
                    this.getRequest(URL_DATA_USER_BASE_PRORATE).then(resp => { if (resp) this.arch_my_userBaseProductRateInfo = resp.data; this.tab2Disable = false;});
                    this.arch_miniRate = this.$root.g_data_mini_rate; // 新进件的费率ID为成本费率的ID
                    break;
                case 'UPD':
                    this.title = '更新服务商信息';
                    this.tab2Disable = false;


                    this.arch_miniRate = new MiniRate();
                    for(let iii=0; iii<this.inAgentInfo.userProductList.length; iii++) {
                        for(let jjj=0; jjj<this.inAgentInfo.userProductList[iii].payProductChannelList.length; jjj++) {
                            for(let kkk=0; kkk<this.inAgentInfo.userProductList[iii].payProductChannelList[jjj].userRateList.length; kkk++) {
                                let userRate = this.inAgentInfo.userProductList[iii].payProductChannelList[jjj].userRateList[kkk];
                                let gMiniRate = this.$root.g_data_mini_rate[userRate.payChannelCode+'-'+userRate.payWayCode+'-'+userRate.payModeCode+'-'+userRate.rateType];
                                // 需要判断gMiniRate是否为null,可能存在一种情况？给商户设置的某条费率信息，在代理商的费率信息里找不到。。。 应该不会。代理商不会删除，可能新增。增量的话，代理商永远包含商户费率信息。
                                // 用费率4要素，去代理商成本费率匹配到最低费率。存在新的最低费率档案里。
                                // 因为最低费率档案，是用ID做索引的，所以新增 和 修改 是有区别的。新增的ID是固定的取成本费率的ID。修改的，每个商户的费率ID都不用，所以需要重组一次最低费率档案。
                                console.log(gMiniRate)
                                this.arch_miniRate.add(userRate.id, gMiniRate.rate, gMiniRate.fixRate, gMiniRate.feeLowest, gMiniRate.feeHighest,
                                    userRate.payChannelCode, userRate.payWayCode, userRate.payModeCode, userRate.rateType);
                            }
                        }
                    }


                    this.agentInfoForm = this.inAgentInfo;
                    this.initFormBef();




                    break;
                default:
                    return;
            }

            this.agentInfoForm.agentPid = this.$store.state.currentHr.agentIdS;
            this.agentInfoForm.agentLevelId = this.$store.state.currentHr.agentLevel + 1;
            // console.log("服务商PID:", this.agentInfoForm.agentPid);
            // console.log("this.$store.state.currentHr.agentIdS", this.$store.state.currentHr.agentIdS);
            // console.log("服务商等级:", this.agentInfoForm.agentLevelId);

            this.showDlg = true;

            // 全部服务商ID列表
            this.getRequest(URL_AGENT_FROMS).then(resp => {
                if (resp) {
                    // 初始 - 代理商编辑时，选择推荐代理商，不包含当前编辑的服务商ID。
                    this.arch_allAgentIdNameWithOutThis = deepClone(resp.data);
                    let idx = findIdxByKeyValue(this.arch_allAgentIdNameWithOutThis, 'id', this.agentInfoForm.id);
                    if(idx) this.arch_allAgentIdNameWithOutThis.splice(idx,1);
                }
            });
        },
        methods: {
            ysfRateTemplateChanged() {
                // console.log(this.ysfTermRateArray)
            },
            //////////////////////////////////////////////////////////////////////
            // 主选项卡 点击
            //////////////////////////////////////////////////////////////////////
            handleMainTabClick(tab, event) {
                switch (this.activeTabName) {
                    case "tab1":
                        break;
                    case "tab2":
                        this.handleTab2();
                        break;
                }
            },
            //////////////////////////////////////////////////////////////////////
            // 获取当前用户基础产品扣率信息
            //////////////////////////////////////////////////////////////////////
            handleTab2() {
                if(this.inOptType==='INS' && this.agentInfoForm.userProductList.length===0) { // 新增 - 深度拷贝 产品费率信息，初始化状态未选中
                    this.agentInfoForm.userProductList = deepClone(this.arch_my_userBaseProductRateInfo);
                    this.agentInfoForm.userProductList.forEach( item => { item.status = 0; });
                }
                else if(this.inOptType==='UPD') {
                    // 遍历当前商户产品列表，状态1选中，状态0取消选中。
                    this.agentInfoForm.userProductList.forEach( item => {
                        if(item.status===1) {
                            this.$refs.prodTable.toggleRowSelection(item,true); // 程序勾选 不会触发@select和@select-all (会触发@selection-change)
                        }
                        else {
                            this.$refs.prodTable.toggleRowSelection(item,false); // 主动勾选 不会触发@select和@select-all (会触发@selection-change)
                        }
                    });
                }
            },
            //////////////////////////////////////////////////////////////////////
            // 获取所有选中的产品代码数组
            //////////////////////////////////////////////////////////////////////
            getSelectRowProductCodeArr() {
                // 获取 - 选中的产品信息
                let selectRow = this.$refs.prodTable.selection;
                let selectRowProductCodeArr = [];
                selectRow.forEach( item => { selectRowProductCodeArr.push(item.payProduct.productCode); });
                return selectRowProductCodeArr;
            },
            //////////////////////////////////////////////////////////////////////
            // 用传入对象 额外初始化一些 当前表单信息
            // 初始化 表单参数 到 特殊组件绑定参数 （展示渲染）
            //////////////////////////////////////////////////////////////////////
            initFormBef() {
                // 初始 - 区域组件绑定值
                this.otherForm.areas.provId = this.agentInfoForm.provId;
                this.otherForm.areas.cityId = this.agentInfoForm.cityId;
                this.otherForm.areas.distId = this.agentInfoForm.distId;
            },
            //////////////////////////////////////////////////////////////////////
            // 用当前表单信息 额外初始化一些 传入对象
            // 初始化 特殊组件绑定参数 到 表单参数 （提交后台）
            //////////////////////////////////////////////////////////////////////
            initFormAft() {
                this.agentInfoForm.sysName = this.agentInfoForm.linkMan
                this.agentInfoForm.sysUserName = this.agentInfoForm.linkPhone



                // 补充 - 提交表单的产品信息
                let selectRowProductCodeArr = this.getSelectRowProductCodeArr();
                if(selectRowProductCodeArr.length===0) {
                    this.$message.error("请选择支付产品!");
                    return false;
                }
                else { // 遍历产品列表，根据选中行产品代码数组，更新状态
                    this.agentInfoForm.userProductList.forEach( item => { item.status = selectRowProductCodeArr.indexOf(item.payProduct.productCode)===-1?0:1; });
                }
                // 补充 - 商户扩展信息 - 从区域组件获取省市区代码
                this.agentInfoForm.provId = this.otherForm.areas.provId;
                this.agentInfoForm.cityId = this.otherForm.areas.cityId;
                this.agentInfoForm.distId = this.otherForm.areas.distId;

                return true;
            },
            //////////////////////////////////////////////////////////////////////
            // 确认提交
            //////////////////////////////////////////////////////////////////////
            handleMainDlgOkClick() {
                if(!this.initFormAft()) // 提交准备
                    return;
                this.$refs['otherForm'].validate(valid => { // 区域表单验证
                    if (valid) { // 商户表单验证
                        this.$refs['agentInfoForm'].validate(valid => {
                            if (valid) {
                                switch (this.inOptType) {
                                    case 'UPD':
                                        this.updateAgentInfo();
                                        break;
                                    case 'INS':
                                        this.insertAgentInfo();
                                        break;
                                    default:
                                        this.$message.error("未知提交操作!");
                                        break;
                                }
                            }
                        });
                    }
                });
            },
            //////////////////////////////////////////////////////////////////////
            // 提交数据库插入表单代理商信息
            //////////////////////////////////////////////////////////////////////
            insertAgentInfo() {
                this.postRequest("/agent/addAgent", this.agentInfoForm).then(resp => {
                    if (resp) {
                        this.showDlg = false;
                        this.emitToParent();
                    }
                })
            },
            //////////////////////////////////////////////////////////////////////
            // 提交数据库更新表单代理商信息
            //////////////////////////////////////////////////////////////////////
            updateAgentInfo() {
                this.putRequest("/agent/updateAgent", this.agentInfoForm).then(resp => {
                    if (resp) {
                        this.showDlg = false;
                        this.emitToParent();
                    }
                })
            },
            emitToParent() {
                this.$emit('update:outDlgClosed', true);
            }
        }
    }
</script>

<style scoped>

</style>
